export const LINK_PROTOCOLS = ['tel:', 'mailto:'];
